export enum OrderSelectionFilter {
    Empresa,
    Trabajador,
    Fecha,
    Autor,
    FechaRegistro,
    Usuario
}

export enum PeriodRadio {
    Actuacion,
    Registro
}

export enum Facturacion {
    Todas = 0,
    Pendientes = 1,
    Facturadas = 2
}